// Connecting the Webshop HTTP API must not force an unfinished migration of
// the existing processed editors. Only an explicit false opts out; deployments
// already using protected writers retain their behavior when this is absent.
export function usesProtectedProcessedWriters(): boolean {
  return Boolean(process.env.REACT_APP_SHOP_API_ORIGIN?.trim()) &&
    process.env.REACT_APP_SHOP_PROCESSED_WRITES_ENABLED?.trim() !== "false";
}
